const MANUAL_ACH_RULES = {
  method: 'manual bank account',
  // minimum: 20, // MINIMUM is deprecated - moved to config toggle in NET-524
  maximum: 200,
  minimumLoadAfterInitial: 1
};

const PLAID_RULES = {
  method: 'bank account',
  // minimum: 20, // MINIMUM is deprecated - moved to config toggle in NET-524
  maximum: 500,
  minimumLoadAfterInitial: 1
};

const DEBIT_RULES = {
  method: 'debit card',
  // minimum: 20, // MINIMUM is deprecated - moved to config toggle in NET-524
  maximum: 500,
  minimumLoadAfterInitial: 20
};

// TODO: Move this to external configuration
const OAUTH_BANK_LIST = ['Chase', 'Wells Fargo', 'Capital One'];

const manualACHMaxError = `To add a bank account manually, you must choose an initial load amount less than or equal to $${MANUAL_ACH_RULES.maximum}.`;

const BANK_NOT_FOUND_STATUS = 'institution_not_found';

export default {
  PLAID_RULES,
  DEBIT_RULES,
  MANUAL_ACH_RULES,
  manualACHMaxError,
  BANK_NOT_FOUND_STATUS,
  OAUTH_BANK_LIST
};
